/* eslint-disable */
// Spanish translation. Keys must mirror the `en` dictionary in strings.js.

export const ES_RISK_LABELS = {
  "Very High": "Muy alto",
  High: "Alto",
  "Intermediate-High": "Intermedio-alto",
  Intermediate: "Intermedio",
  Low: "Bajo",
  "Very Low": "Muy bajo",
};

export const ES = {
  "layout.subtitle": "Simulador Clínico · v1.0.0",
  "layout.poweredBy": "Powered by",
  "layout.signIn": "Iniciar sesión",
  "layout.logout": "Cerrar sesión",
  "nav.overview": "Resumen",
  "nav.simulator": "Simulador",
  "nav.configuration": "Configuración",
  "nav.api": "API",
  "footer.source": "Fuente: Simulatore SEPSI_EMO (20250822) · LDA + Árboles de decisión",
  "footer.tech": "Desplegable en Azure · Configuración JSON · Persistencia MongoDB",
  "lang.label": "Idioma",

  "ov.kicker": "Soporte a la Decisión Clínica · 01",
  "ov.titleA": "Sepsi Index Framework",
  "ov.titleB": "plataforma de cálculo.",
  "ov.description":
    "Un framework diseñado para distinguir los casos de Sepsis de otras enfermedades o infecciones a partir de los analitos del hemograma.",
  "ov.openSimulator": "Abrir el Simulador de Paciente →",
  "ov.editConfig": "Editar Configuración",
  "ov.activeConfig": "Configuración Activa",
  "ov.card.variables": "Variables",
  "ov.card.variables.sub": "valores hematológicos de entrada",
  "ov.card.classes": "Clases LDA",
  "ov.card.classes.sub": "Sin SEPSIS + 4 días de alerta",
  "ov.card.rules": "Reglas de Decisión",
  "ov.card.rules.sub": "reglas hoja del árbol",
  "ov.card.version": "Versión de Configuración",
  "ov.sponsor.label": "Un proyecto respaldado por",
  "ov.sponsor.tagline": "AI-Care for a better life",
  "ov.step": "Paso",
  "ov.step1.title": "Introducción de datos clínicos",
  "ov.step1.body":
    "El médico accede a la aplicación desde el móvil (APP) o el ordenador (webapp) e introduce los valores del hemograma del paciente, ya disponibles en la fase inicial de la evaluación en Urgencias.",
  "ov.step2.title": "Cálculo del indicador predictivo",
  "ov.step2.body":
    "El sistema procesa automáticamente los datos mediante tres modelos predictivos independientes. El médico puede consultar y seleccionar el modelo que considere más coherente con el perfil clínico del paciente, manteniendo el pleno control de la decisión.",
  "ov.step3.title": "Resultado clínico y soporte a la decisión",
  "ov.step3.bodyIntro": "La aplicación proporciona:",
  "ov.step3.bullet1": "un porcentaje de probabilidad de sepsis,",
  "ov.step3.bullet2":
    "alertas de riesgo para los primeros 4 días tras el análisis, ofreciendo un apoyo temprano a la estratificación del riesgo, sin sustituir el juicio clínico.",

  "sim.kicker": "Sección 02",
  "sim.title": "Simulador de Paciente",
  "sim.description":
    "Introduzca los 20 valores hematológicos, elija un preajuste o edite campo por campo. En cada cálculo, la API devuelve el Análisis Discriminante Lineal, el Árbol de Decisión y el riesgo combinado.",
  "sim.sponsoredBy": "Patrocinado por",
  "sim.reset": "Restablecer",
  "sim.calculate": "Calcular el Riesgo de Sepsis →",
  "sim.calculating": "Calculando…",
  "sim.awaiting.title": "En espera del cálculo",
  "sim.awaiting.body":
    "Complete el formulario (o cargue un preajuste) y pulse Calcular para ver el análisis discriminante, la ruta del árbol de decisión y la clase de riesgo combinada.",
  "sim.group.neutrophils": "Neutrófilos",
  "sim.group.lymphocytes": "Linfocitos",
  "sim.group.monocytes": "Monocitos",
  "sim.group.rdw": "Variabilidad eritrocitaria (RDW)",
  "sim.group.ratios": "Cocientes",
  "sim.group.platelets": "Plaquetas",
  "sim.result.combined": "Probabilidad Combinada de Sepsis",
  "sim.result.compare": "Comparación de metodologías",
  "sim.result.perClass": "Probabilidad por clase (combinada)",
  "sim.result.path": "Ruta del árbol de decisión · nodo",
  "sim.method.lda": "Discriminante Lineal",
  "sim.method.tree": "Árboles de Decisión",
  "sim.method.combined": "Combinado (MAX)",
  "sim.result.txId": "ID de Transacción",
  "sim.result.txIdHint": "Guarde este ID en la historia clínica del paciente para validar la predicción más adelante.",
  "sim.result.copy": "Copiar",
  "sim.result.copied": "Copiado",
  "sim.patientRef.label": "Referencia del paciente (opcional)",
  "sim.patientRef.placeholder": "ej. n.º de historia clínica o ID interno",
  "sim.patientRef.help": "Opcional. Se guarda con la transacción: podrá encontrar esta predicción desde el Historial buscando por referencia.",
  "sim.result.patientRef": "Referencia del paciente",

  "cfg.kicker": "Sección 03",
  "cfg.title": "Configuración",
  "cfg.description":
    "Edite los pesos, las hojas del árbol de decisión, los umbrales de riesgo y los usuarios autorizados. Los cambios se guardan en MongoDB.",
  "cfg.import": "Importar Excel…",
  "cfg.export": "Exportar JSON",
  "cfg.reset": "Restablecer valores por defecto",
  "cfg.save": "Guardar",
  "cfg.saving": "Guardando…",
  "cfg.saved": "Configuración guardada",
  "cfg.resetDone": "Configuración por defecto restablecida",
  "cfg.extracted": "Extraído del Excel — pulse Guardar para activarlo",
  "cfg.tab.lda": "Pesos discriminantes",
  "cfg.tab.tree": "Árbol de decisión",
  "cfg.tab.thresholds": "Umbrales de riesgo",
  "cfg.tab.users": "Usuarios",
  "cfg.tab.apitokens": "Tokens API",
  "tok.title": "Tokens API",
  "tok.subtitle": "Tokens bearer de larga duración para clientes servidor a servidor (p. ej. una Azure Function). Cada token está vinculado a un correo «robot» que ya debe figurar en la lista de autorizados — eliminarlo desactiva al instante todos los tokens emitidos para esa identidad.",
  "tok.create.heading": "Generar un nuevo token API",
  "tok.create.name": "Nombre",
  "tok.create.name.placeholder": "ej. Azure Function — Producción",
  "tok.create.email": "Correo robot",
  "tok.create.email.help": "Elija una identidad ya presente en la lista de autorizados. El correo robot aparecerá en cada fila del registro clínico generada por este token.",
  "tok.create.email.empty": "No hay correos en la lista de autorizados. Añada uno primero desde la pestaña Usuarios.",
  "tok.create.ttl": "Validez",
  "tok.create.ttl.30": "30 días",
  "tok.create.ttl.90": "90 días",
  "tok.create.ttl.365": "1 año",
  "tok.create.ttl.none": "Sin caducidad (solo revocación)",
  "tok.create.submit": "Generar token",
  "tok.create.submitting": "Generando…",
  "tok.minted.title": "Token creado — cópielo ahora",
  "tok.minted.warning": "Es la única vez que se mostrará el token completo. Guárdelo en un gestor de secretos (Azure Key Vault, AWS Secrets Manager, etc.) antes de cerrar este aviso.",
  "tok.minted.copy": "Copiar token",
  "tok.minted.copied": "Copiado",
  "tok.minted.dismiss": "Ya lo he guardado — cerrar",
  "tok.list.heading": "Tokens existentes",
  "tok.list.empty": "Todavía no se ha emitido ningún token API.",
  "tok.col.name": "Nombre",
  "tok.col.robot": "Correo robot",
  "tok.col.created": "Creado",
  "tok.col.expires": "Caduca",
  "tok.col.lastUsed": "Último uso",
  "tok.col.status": "Estado",
  "tok.status.active": "Activo",
  "tok.status.revoked": "Revocado",
  "tok.status.expired": "Caducado",
  "tok.noExpiry": "Sin caducidad",
  "tok.never": "Nunca",
  "tok.revoke": "Revocar",
  "tok.revoke.confirm": "¿Revocar este token? Los clientes que lo usen recibirán inmediatamente un error 401.",
  "cfg.lda.variable": "Variable",
  "cfg.lda.intercept": "Constante",
  "cfg.tree.node": "Nodo",
  "cfg.tree.count": "Recuento",
  "cfg.thr.threshold": "Umbral (≥)",
  "cfg.thr.labelEn": "Etiqueta (EN)",
  "cfg.thr.labelIt": "Etiqueta (IT)",
  "cfg.thr.labelFr": "Etiqueta (FR)",
  "cfg.thr.labelEs": "Etiqueta (ES)",
  "cfg.users.title": "Usuarios autorizados",
  "cfg.users.active": "activos",
  "cfg.users.you": "Usted · no eliminable",
  "cfg.users.remove": "Eliminar",
  "cfg.users.invite": "Invitar a un nuevo usuario",
  "cfg.users.help":
    "Añada una dirección de correo de Google. El usuario podrá iniciar sesión con Google y acceder a las páginas protegidas en cuanto su correo figure en esta lista. Eliminar un correo revoca los inicios de sesión futuros (los tokens existentes caducan en 12 h).",
  "cfg.users.add": "Añadir a la lista",
  "cfg.users.signedIn": "Sesión iniciada actualmente como",
  "cfg.users.loading": "Cargando usuarios…",
  "cfg.errors.invalidEmail": "Formato de correo no válido",
  "cfg.errors.dup": "El correo ya está en la lista",
  "cfg.errors.removeSelf": "No puede eliminar su propia dirección",
  "cfg.users.updated": "Usuarios autorizados actualizados",
  "cfg.loading": "Cargando la configuración…",

  "login.kicker": "Acceso restringido",
  "login.titleA": "Inicie sesión para acceder",
  "login.titleB": "a la plataforma.",
  "login.description":
    "El Simulador y la Configuración están reservados a una lista de correos autorizados. Solo el Resumen público es accesible sin autenticación.",
  "login.step1": "Pulse Iniciar sesión con Google",
  "login.step2": "Autorice en la ventana de Google",
  "login.step3": "Su correo se compara con la lista del servidor",
  "login.step4": "Si todo va bien, se le redirige a su destino",
  "login.provider": "Google OAuth 2.0",
  "login.cta": "Iniciar sesión con Google",
  "login.signingIn": "Iniciando sesión…",
  "login.note":
    "Solo leemos su dirección de correo. Su correo debe figurar en la lista de autorizados para obtener un token de sesión.",
  "login.errors.failed": "Error al iniciar sesión",
  "login.errors.cancelled": "Se canceló el inicio de sesión con Google",

  "auth.checking": "Comprobando la autenticación…",

  "nav.transactions": "Historial",
  "tx.kicker": "Auditoría Clínica · 05",
  "tx.title": "Historial de transacciones",
  "tx.description":
    "Cada predicción se registra con la entrada, la salida y el solicitante. Como administrador, puede validar cada caso como Correcto o Incorrecto para apoyar el análisis retrospectivo de la precisión y el ajuste futuro del modelo.",
  "tx.filter.all": "Todas",
  "tx.filter.pending": "Pendientes",
  "tx.filter.yes": "Correctas (SÍ)",
  "tx.filter.no": "Incorrectas (NO)",
  "tx.filter.caller": "Filtrar por correo del solicitante…",
  "tx.filter.id": "Buscar por ID de transacción…",
  "tx.filter.ref": "Buscar por referencia del paciente…",
  "tx.filter.clear": "Borrar",
  "tx.export.csv": "Exportar CSV",
  "tx.export.csv.exporting": "Exportando…",
  "tx.export.csv.help": "Descarga todas las transacciones que coinciden con los filtros activos en formato CSV (compatible con Excel, UTF-8 con BOM). Incluye una columna por cada variable del paciente.",
  "tx.empty": "Todavía no hay transacciones. Ejecute un cálculo desde el Simulador (o llame a POST /api/calculate) para registrar la primera.",
  "tx.empty.search": "Ninguna transacción coincide con su búsqueda.",
  "tx.col.id": "ID de Transacción",
  "tx.col.ref": "Ref. paciente",
  "tx.col.when": "Fecha",
  "tx.col.caller": "Solicitante",
  "tx.col.prob": "P(SEPSIS)",
  "tx.col.class": "Clase de riesgo",
  "tx.col.validation": "Validación",
  "tx.col.actions": "",
  "tx.copyId": "Copiar ID de transacción",
  "tx.detail.expand": "Mostrar detalles",
  "tx.detail.collapse": "Ocultar detalles",
  "tx.delete": "Eliminar",
  "tx.delete.confirm": "¿Eliminar definitivamente esta transacción? Esta acción no se puede deshacer — la predicción se retirará del registro clínico y de las estadísticas de precisión.",
  "tx.detail.input": "Entrada",
  "tx.detail.output": "Salida (combinada)",
  "tx.detail.path": "Ruta del árbol de decisión",
  "tx.validation.pending": "Pendiente",
  "tx.validation.yes": "Correcto",
  "tx.validation.no": "Incorrecto",
  "tx.validation.markYes": "Marcar como Correcto",
  "tx.validation.markNo": "Marcar como Incorrecto",
  "tx.validation.clear": "Restablecer",
  "tx.validation.notes": "Notas (opcional)",
  "tx.validation.notesPh": "Observaciones clínicas, referencia de la historia, seguimiento…",
  "tx.validation.save": "Guardar validación",
  "tx.validation.by": "Validado por",
  "tx.validation.at": "el",
  "tx.stats.total": "Total",
  "tx.stats.pending": "Pendientes",
  "tx.stats.yes": "Correctas",
  "tx.stats.no": "Incorrectas",
  "tx.loading": "Cargando transacciones…",
  "tx.refresh": "Actualizar",

  "nav.accuracy": "Precisión",
  "acc.kicker": "Rendimiento del Modelo · 06",
  "acc.title": "Precisión retrospectiva",
  "acc.description":
    "Precisión en tiempo real del modelo predictivo, basada en las validaciones SÍ/NO registradas en el Historial. Úsela para vigilar la deriva del rendimiento, identificar las clases de riesgo más débiles y orientar el reajuste del modelo.",
  "acc.refresh": "Actualizar",
  "acc.headline.label": "Precisión validada",
  "acc.headline.empty": "Todavía no hay casos validados — vaya al Historial y valide algunas transacciones para alimentar el panel.",
  "acc.headline.basis": "basado en",
  "acc.headline.basis2": "casos validados",
  "acc.summary.total": "Transacciones totales",
  "acc.summary.validated": "Validadas",
  "acc.summary.pending": "Pendientes de revisión",
  "acc.summary.coverage": "Cobertura",
  "acc.byClass.title": "Precisión por clase de riesgo",
  "acc.byClass.empty": "Valide al menos un caso para ver el desglose por clase de riesgo.",
  "acc.byClass.class": "Clase de riesgo",
  "acc.byClass.cases": "Casos",
  "acc.byClass.correct": "Correctos",
  "acc.byClass.incorrect": "Incorrectos",
  "acc.byClass.accuracy": "Precisión",
  "acc.byDay.title": "Últimos N días",
  "acc.byDay.subtitle": "Precisión diaria (solo se muestran los días con validaciones)",
  "acc.byDay.empty": "No hay casos validados en este periodo.",
  "acc.byCaller.title": "Principales solicitantes",
  "acc.byCaller.empty": "Todavía no hay solicitantes con casos validados.",
  "acc.byCaller.email": "Solicitante",
  "acc.byCaller.cases": "Casos",
  "acc.byCaller.accuracy": "Precisión",
  "acc.window.7": "7 días",
  "acc.window.30": "30 días",
  "acc.window.90": "90 días",
  "acc.window.all": "Todo",
  "acc.loading": "Calculando métricas…",

  "docs.kicker": "Referencia para Desarrolladores · 04",
  "docs.title": "API para clientes HTTP",
  "docs.intro":
    "Sepsi Index Framework expone una API REST. Cualquier cliente HTTP (curl, Postman, Python, un servicio backend…) puede calcular el riesgo de sepsis tras autenticarse con una **identidad de Google** que figure en la lista de usuarios autorizados.",
  "docs.interactive.title": "Documentación interactiva",
  "docs.interactive.body":
    "El esquema OpenAPI 3.1 completo se genera automáticamente. Use Swagger UI para probar cada endpoint en directo (pegue un ID token de Google en **Authorize**), o importe el JSON en Postman, Insomnia o un generador de código OpenAPI.",
  "docs.interactive.swagger": "Abrir Swagger UI",
  "docs.baseUrl": "URL base",
  "docs.auth.title": "Autenticación",
  "docs.auth.intro":
    "Envíe un token Bearer en la cabecera `Authorization`. El servidor acepta **dos formatos equivalentes** de token:",
  "docs.auth.google.title": "ID token de Google (recomendado para clientes HTTP)",
  "docs.auth.google.body":
    "— cualquier ID token emitido por el OAuth de Google para nuestro client ID ({clientId}). Debe estar firmado con RS256, tener un correo verificado y el correo debe figurar en la lista de autorizados.",
  "docs.auth.app.title": "JWT de la aplicación",
  "docs.auth.app.body":
    "— el token HS256 de corta duración devuelto por `POST /api/auth/google` (usado por la SPA tras la ventana emergente de Google).",
  "docs.auth.errors":
    "En caso de `401` la respuesta incluye `WWW-Authenticate: Bearer`. Un `403` significa que el token es válido pero el correo **no figura en la lista de autorizados** — pida a un administrador que lo añada desde la página **Configuración → Usuarios**.",
  "docs.endpoints.title": "Endpoints",
  "docs.col.method": "Método",
  "docs.col.path": "Ruta",
  "docs.col.auth": "Auth",
  "docs.col.desc": "Descripción",
  "docs.bearerRequired": "Bearer obligatorio",
  "docs.public": "público",
  "docs.ep.calculate": "Calcula el riesgo de sepsis para un paciente.",
  "docs.ep.health": "Sonda de disponibilidad (número de variables/reglas/versión).",
  "docs.ep.config": "Devuelve la configuración activa (solo lectura).",
  "docs.ep.examples": "Tres casos de paciente predefinidos (riesgo bajo / medio / alto).",
  "docs.ep.configPut": "Sustituye la configuración activa (admin).",
  "docs.ep.configReset": "Restablece el modelo por defecto (conserva la lista de autorizados).",
  "docs.ep.configExtract": "Extrae una configuración de un Excel de referencia (subida multipart).",
  "docs.ep.emailsGet": "Lista los usuarios autorizados.",
  "docs.ep.emailsPut": "Sustituye la lista de autorizados.",
  "docs.payload.title": "Cuerpo de la petición — POST /api/calculate",
  "docs.payload.body":
    "El cuerpo contiene un único objeto `patient` con los 20 valores hematológicos. Los valores ausentes se tratan como cero en el modelo LDA y omiten las condiciones correspondientes del árbol de decisión.",
  "docs.curl.title": "Ejemplo · curl + gcloud",
  "docs.curl.body":
    "La forma más sencilla: una vez iniciada la sesión en gcloud (`gcloud auth login`) puede generar ID tokens de corta duración asociados a nuestro cliente OAuth.",
  "docs.python.title": "Ejemplo · Python",
  "docs.python.body":
    "Requiere un **cliente OAuth de tipo Aplicación de escritorio** en Google Cloud Console (distinto del cliente Web usado por la SPA). En la primera ejecución el script abre una pestaña del navegador una vez; las ejecuciones siguientes reutilizan automáticamente el refresh token guardado.",
  "docs.s2s.title": "Servidor a servidor (cuenta de servicio)",
  "docs.s2s.body":
    "Para integraciones backend, cree una **cuenta de servicio** de Google Cloud, añada su correo (`name@project.iam.gserviceaccount.com`) a la lista de autorizados y use `google.oauth2.service_account.IDTokenCredentials` con `target_audience` igual a nuestro OAuth Client ID. El ID token generado funciona de la misma manera.",
  "docs.copy": "COPIAR",
  "docs.copied": "COPIADO",
};
